import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import legalAssociationsViolentOrganizationItemValidator from './validators/item';
import { LegalAssociationsViolentOrganizationModel } from './types';

const legalAssociationsViolentOrganizationValidator: ValidateJSModel<LegalAssociationsViolentOrganizationModel> = {
  HasViolentOrganization: { presence: true, hasValue: { validator: hasYesOrNo } },

  List: (value, attributes) => {
    if (attributes?.HasViolentOrganization?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: legalAssociationsViolentOrganizationItemValidator },
      };
    }
    return {};
  },
};

export default legalAssociationsViolentOrganizationValidator;
